import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearPendingResetOperationAction = (
  state: PlanboardState,
  action: PayloadAction<string>
) => {
  const correlationId = action.payload;
  delete state.pendingResetOperations[correlationId];
};
